<template>
  <v-dialog persistent :fullscreen="isMobile" v-model="dialog" transition="dialog-bottom-transition" max-width="50%"
    scrollable>
    <v-card color="black" class="overflow-y-auto !rounded-none border-0" min-height="20vh">
      <v-card-title class="font-Handel !text-2xl !font-semibold " :class="`${routeLink}_fortext`">Search With Filter
      </v-card-title>
      <v-card-text min-height="20vh" class="scrollbar_hider">
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12">
              <v-card-subtitle class="white--text !text-xl font-Handel !px-0">
                Select Interest
              </v-card-subtitle>
              <v-chip-group :active-class="`${routeLink}_color text-black`" outlined column v-model="interestTypes">
                <v-chip outlined :color="colorAsRoute" class="!px-5 font-Handel" value="3">
                  Straight
                </v-chip>
                <v-chip outlined :color="colorAsRoute" class="!px-5 font-Handel" value="1">
                  Lesbian
                </v-chip>
                <v-chip outlined :color="colorAsRoute" class="!px-5 font-Handel" value="2">
                  Gay
                </v-chip>
              </v-chip-group>
            </v-col>
            <v-col cols="12">
              <v-card-subtitle class="white--text !text-xl font-Handel !px-0">
                Select Age Range
              </v-card-subtitle>
              <v-range-slider dark :color="colorAsRoute" v-model="partner_age_range" :max="max" :min="min" hide-details
                class="align-center">
                <template v-slot:prepend>
                  <v-text-field :value="partner_age_range[0]" solo dense class="pt-0 mt-0 font-Handel"
                    :background-color="colorAsRoute" hide-details single-line type="number" style="width: 65px"
                    @change="$set(partner_age_range, 0, $event)">
                  </v-text-field>
                </template>
                <template v-slot:append>
                  <v-text-field :value="partner_age_range[1]" :background-color="colorAsRoute" solo dense
                    class="pt-0 mt-0 font-Handel" hide-details single-line type="number" style="width: 65px"
                    @change="$set(partner_age_range, 1, $event)">
                  </v-text-field>
                </template>
              </v-range-slider>
            </v-col>

            <v-col cols="12">
              <v-card-subtitle class="white--text !text-xl font-Handel !px-0 mt-5">
                Select Hobbies
              </v-card-subtitle>
              <v-select v-model="hobbies" solo dense class="font-Handel scrollbar_hider"
                :class="`${routeLink}_v-select`" dark :item-color="colorAsRoute" item-text="title" deletable-chips
                small-chips :items="getInterests" item-value="title" attach chips label="Select Hobbies" />
              <!-- <v-select v-model="hobbies" :class="`${routeLink}_v-select`" :item-color="colorAsRoute"
                :items="interests" item-value="id" item-text="title" flat dark deletable-chips small-chips attach chips
                label="Select Hobbies" multiple :rules="hobbiesRule" class="my-2" /> -->
              <v-col cols="12">
                <v-card-subtitle class="white--text !text-xl font-Handel !px-0">
                  Select Area Radius
                </v-card-subtitle>
                <v-slider min="1" max="50" :color="colorAsRoute" dark v-model="radius" label="Select Radius(m)"
                  :thumb-label="true"></v-slider>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn width="100" dark @click.prevent="setSearchFilters" class="white--text " :class="`${routeLink}_color`">
          Apply</v-btn>
        <v-btn dark @click.prevent="$emit('close-dialog')" text>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import defaultMixin from "../../mixins";
export default {
  name: "ProfileFilter",
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      interestTypes: this.$store.getters.StateUser.data.account_type,
      min: 18,
      max: 50,
      partner_age_range: [20, 30],
      interests: [],
      items: [
        "Volunteering and community involvement",
        "Writing",
        "Blogging",
        "Podcasting",
        "Marketing",
        "Photography",
        "Learning languages",
        "Travel",
        "Sports",
        "Yoga",
        "Dance",
        "Art",
        "Reading",
        "Making music",
        "Listening to music",
      ],
      hobbies: [],
      radius: 10,
    };
  },
  computed: {

    getInterests() {
      return this.$store.getters.interests;
    },
    colorAsRoute() {
      if (this.routeLink == 'straight') {
        return '#a07a1d'
      }
      else if (this.routeLink == 'gay') {
        return '#88c3fa'
      }
      else if (this.routeLink == 'lesbian') {
        return '#9e2eec'
      }
    }
  },
  methods: {
    setSearchFilters() {
      this.$store.commit("setSearchFilters", {
        age_from: this.partner_age_range[0],
        age_to: this.partner_age_range[1],
        hobbies: this.hobbies,
        radius: this.radius,
        interestType: this.interestTypes
      });

      this.$emit("close-dialog");
    },
  },

};
</script>

<style scoped>
.straight_color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(345deg,
      rgb(97 69 0) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(90 64 0 / 97%) 100%);
}

.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg,
      rgba(0, 240, 255, 1) 55%,
      rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_color {
  background: rgb(126, 0, 157);
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
}

.gay_color {
  background: rgb(0, 240, 255);
  background: linear-gradient(39deg,
      rgba(0, 240, 255, 1) 0%,
      rgba(0, 156, 255, 1) 100%);
}


.v-select:deep(.v-input__slot) {
  background-color: #111 !important;
}

.v-select:deep(label) {
  color: white !important;
}

.v-select:deep(.v-list) {
  background-color: #111;
}

/* .v-text-field:deep(.v-input__slot) {
 background-color: #ae8c39 !important;
} */

.straight_v-select:deep(.v-list-item__title) {
  color: #ae8c39;
}

.straight_v-select:deep(.v-chip) {
  background-color: #ae8c39 !important;
}

.gay_v-select:deep(.v-list-item__title) {
  color: #88c3fa;
}

.gay_v-select:deep(.v-chip) {
  background-color: #88c3fa !important;
}

.lesbian_v-select:deep(.v-list-item__title) {
  color: #9e2eec;
}

.lesbian_v-select:deep(.v-chip) {
  background-color: #9e2eec !important;
}

.v-input__slider:deep(label) {
  color: white !important;
}

.scrollbar_hider::-webkit-scrollbar {
  display: none !important;
}

.scrollbar_hider:deep(::-webkit-scrollbar) {
  display: none !important;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollbar_hider {
  -ms-overflow-style: none !important;
  /* IE and Edge */
  scrollbar-width: none !important;
  /* Firefox */
}

.scrollbar_hider:deep(::-webkit-scrollbar) {
  -ms-overflow-style: none !important;
  /* IE and Edge */
  scrollbar-width: none !important;
  /* Firefox */
}
</style>
